var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 24,
    viewBox: "0 0 41 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3355 14.5956C21.9353 14.5956 23.2322 13.3084 23.2322 11.7206C23.2322 10.1328 21.9353 8.84558 20.3355 8.84558C18.7356 8.84558 17.4387 10.1328 17.4387 11.7206C17.4387 13.3084 18.7356 14.5956 20.3355 14.5956Z",
    fill: "#F1935C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1544 11.4762C30.3027 9.28952 28.824 7.39846 26.9012 6.03677C24.9783 4.67507 22.6956 3.90243 20.3351 3.81433C17.9747 3.90243 15.6919 4.67507 13.7691 6.03677C11.8462 7.39846 10.3676 9.28952 9.5158 11.4762C9.45828 11.6341 9.45828 11.807 9.5158 11.965C10.3676 14.1516 11.8462 16.0427 13.7691 17.4044C15.6919 18.7661 17.9747 19.5387 20.3351 19.6268C22.6956 19.5387 24.9783 18.7661 26.9012 17.4044C28.824 16.0427 30.3027 14.1516 31.1544 11.965C31.212 11.807 31.212 11.6341 31.1544 11.4762ZM20.3351 16.3925C19.4041 16.3925 18.494 16.1185 17.7199 15.6051C16.9458 15.0918 16.3425 14.3621 15.9862 13.5084C15.63 12.6548 15.5367 11.7154 15.7184 10.8091C15.9 9.90289 16.3483 9.07044 17.0066 8.41707C17.6649 7.76369 18.5037 7.31874 19.4168 7.13848C20.3299 6.95821 21.2764 7.05073 22.1365 7.40433C22.9966 7.75793 23.7318 8.35674 24.249 9.12503C24.7662 9.89331 25.0423 10.7966 25.0423 11.7206C25.0404 12.9591 24.5439 14.1463 23.6615 15.022C22.7791 15.8977 21.583 16.3906 20.3351 16.3925Z",
    fill: "#F1935C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewEye);
export default __webpack_public_path__ + "static/media/View_eye.834afe35a1f04775a811c8171470013e.svg";
export { ForwardRef as ReactComponent };